/* eslint-disable react/prop-types */
import React, { FC, HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { Flex, Text, Box } from '@chakra-ui/core'
import { getStoreFront_orderConfig as IOrderConfig } from '@engyalo/storefront-types/lib/graphql/storefront'
import { IConfig } from '@engyalo/storefront-types/lib/plugins/model'
import { Button } from '@engyalo/storefront-components'
import { configState, orderConfigState } from '../../recoil/atoms'
import { ErrorTypes } from '../../lib/constants'
import generalErrorIcon from '../../icons/error.svg'
import orderConfigErrorIcon from '../../icons/errorTll.svg'

interface IProps extends HTMLAttributes<HTMLDivElement> {
  type: number
}

interface IMessage {
  title: string
  message: string
}

const GENERAL_ERROR_OBJ = {
  title: 'error-order',
  message: 'error-order-message',
}

const ORDER_CREATED_ERROR_OBJ = {
  title: 'error-order-created',
  message: 'error-order-created-message',
}

const TTL_ERROR_OBJ = {
  title: 'error-order-ttl',
  message: 'error-order-ttl-message',
}

export const Error: FC<IProps> = ({ type }: IProps) => {
  const { t } = useTranslation()
  const config = useRecoilValue<IConfig>(configState)
  const orderConfig = useRecoilValue<IOrderConfig>(orderConfigState)
  const [message, setMessage] = React.useState<IMessage>(GENERAL_ERROR_OBJ)

  React.useEffect(() => {
    switch (type) {
      case ErrorTypes.GENERAL_ERROR:
        setMessage(GENERAL_ERROR_OBJ)
        break
      case ErrorTypes.ORDER_CREATED_ERROR:
        setMessage(ORDER_CREATED_ERROR_OBJ)
        break
      case ErrorTypes.TTL_ERROR:
        setMessage(TTL_ERROR_OBJ)
        break
      default:
        setMessage(GENERAL_ERROR_OBJ)
        break
    }
  }, [type])

  const goToWhatsApp = () => {
    window.location.href = `http://wa.me/${orderConfig.channelID}`
  }

  return (
    <Flex h="100%" w="100%" flexDirection="column">
      <Flex
        w="100%"
        maxW="42.5rem"
        justifyContent="space-between"
        padding="0.8rem 0.8rem 0 0.8rem"
        position="sticky"
        top={0}
        flex="0 0 auto"
        zIndex={2}
        background="white"
        flexDir="column"
      >
        <Flex
          h="40px"
          w="100%"
          maxW="42.5rem"
          justifyContent="space-between"
          padding="0.8rem 0.8rem 0 0.8rem"
          flex="0 0 auto"
        >
          <img alt="logo" height="100%" src={config.logo} />
        </Flex>
      </Flex>
      <Box
        flex="1"
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        h="100%"
        overflowY="scroll"
      >
        <img
          alt="Yalo"
          src={type === ErrorTypes.ORDER_CREATED_ERROR ? orderConfigErrorIcon : generalErrorIcon}
          width="48rem"
          height="48rem"
        />
        <Text fontSize="md" textAlign="center" whiteSpace="pre-line" marginTop="0.8rem">
          {t(message.title)}
        </Text>
        <Text fontSize="sm" textAlign="center" whiteSpace="pre-line" color="gray.100" marginTop="0.4rem">
          {t(message.message)}
        </Text>
        {type === ErrorTypes.ORDER_CREATED_ERROR && (
          <Box width="18.4rem" marginTop="5.4rem">
            {<Button onClick={goToWhatsApp}>{t('error-button')}</Button>}
          </Box>
        )}
      </Box>
    </Flex>
  )
}

export default Error
